export const removeUtmParams = (url: string): string =>
  url.replace(
    /(\?)utm[^&]*(?:&utm[^&]*)*&(?=(?!utm[^\s&=]*=)[^\s&=]+=)|\?utm[^&]*(?:&utm[^&]*)*$|&utm[^&]*/gi,
    "$1",
  );
